/**
 * @file   请求接口
 * @create zhangchen 2020/11/06
 */
import { http } from "./http";
import {
  listFilter,
  detailFilter,
  fileFilter,
  // exhListFilter,
  // exhBaseListFilter,
  // exhDetailFilter,
  // colListFilter,
  // colDetailFilter,
  // actListFilter,
  // actDetailFilter,
  // exhBaseDetailFilter,
  // exhibitionTypeFilter,
  // searchListFilter,
  // dictionaryTypeFilter,
  // leaveWordListFilter
} from "./filter";
import { CMSGATEWAY, FILEGATEWAY, SEARCHGATEWAY } from "./http";

export const queryAllChannel = async (channel) => {
  const res = await http.get(
    `/${CMSGATEWAY}/api/queryAllChannel/${channel ? channel : "CN"}`
  );
  const data = res.data.data.records;
  return {
    records: data,
  };
};
// 文章
export const queryArchivesById = async (id) => {
  const res = await http.get(`/${CMSGATEWAY}/api/queryArchivesById/${id}`);
  const data = res.data.data;
  return detailFilter(data);
};
export const queryArchivesByNo = async (no) => {
  const res = await http.get(`/${CMSGATEWAY}/api/queryArchivesByNo/${no}`);
  const data = res.data.data;
  return {
    records: detailFilter(data),
  };
};
export const queryArchivesList = async (
  options = { pagination: {}, resource: "", params: {} }
) => {
  const { pagination, params, resource } = options;
  if (!resource)
    return {
      records: [],
      pages: 0,
      page: 0,
      total: 0,
      $$rawData: {},
    };
  const res = await http.post(`/${CMSGATEWAY}/api/queryArchivesList`, {
    entity: {
      channelNo: resource,
      ...params,
    },
    param: {
      pageSize: pagination.size,
      pageNum: pagination.page,
    },
  });
  return {
    ...res.data.data,
    records: listFilter(res.data.data.records),
  };
};
export const apiSearch = async (
  options = { pagination: {}, resource: "", params: {} }
) => {
  const { pagination, params } = options;

  const res = await http.post(`/${CMSGATEWAY}/portalArchives/queryPageList`, {
    entity: {
      channelId: params.channelId,
      title: params.key,
    },
    param: {
      pageSize: pagination.size,
      pageNum: pagination.page,
      // whereSql: ` or t.subTitle like '%${params.key}%'`,
    },
  });
  return {
    ...res.data.data,
    records: listFilter(res.data.data?.records),
  };
};
// 附件
export const queryFileList = async (
  options = { pagination: {}, params: {} }
) => {
  const result = {
    records: [],
    pages: 0,
    page: 0,
    total: 0,
    $$rawData: {},
  };
  if (!options.params.groupId) return result;
  const { pagination, params } = options;

  const res = await http.post(`/${FILEGATEWAY}/refFileObject/queryPageList`, {
    objectId: params.groupId, // 关联id
    code: params.code ? params.code : "", // 文件类型
    pageSize: pagination.size,
    pageNum: pagination.page,
  });
  const data = res.data.data;
  return {
    records: fileFilter(data.records),
    pages: data.pages,
    page: data.current,
    total: data.total,
    $$rawData: data,
  };
};

export const queryQes = async () => {
  const res = await http.get(`${CMSGATEWAY}/api/getRandomQuestions?number=5`);
  const data = res.data.data;
  return {
    records: data,
    // pages: data.pages,
    // page: data.current,
    // total: data.total,
    $$rawData: data,
  };
};
